import api from "./api";

/*
 * A staff user's profile photo as an object URL, or null when there is none (2026-10-15).
 *
 * GET /v1/{p}/user/{id}/profile-picture answers HTTP 200 with the JPEG when the user has a
 * photo, and HTTP 201 with JSON {"message": "Profile picture not found"} (or "User not found")
 * when not - since 10-15 photos are per practice, so every user of a newer practice (OSA user
 * 27 ...) starts without one. api.js hands over only the body, here a Blob: an image Blob
 * (image/* type, which the route sends only with its 200 file answer) becomes an object URL;
 * a JSON Blob, an empty Blob or a failed request is "no photo", so the caller shows its
 * placeholder / initials instead of a broken image.
 */
export function isImageBlob(body) {
  return (
    typeof Blob !== "undefined" &&
    body instanceof Blob &&
    body.size > 0 &&
    /^image\//i.test(body.type || "")
  );
}

export async function profilePhotoObjectUrl(practiceId, userId) {
  if (!practiceId || !userId) return null;
  let body;
  try {
    body = await api.get(`/v1/${practiceId}/user/${userId}/profile-picture?ts=${Date.now()}`, {
      responseType: "blob",
    });
  } catch (e) {
    return null;
  }
  return isImageBlob(body) ? URL.createObjectURL(body) : null;
}
